import { useCallback } from 'react';
import { PlayerSource } from '@landr/react-player';
import { useNotificationsContext } from 'contexts/NotificationsContext/NotificationsContext';
import { PlayerFailedToPlayError } from 'contexts/NotificationsContext/notifications';

export type OnError = ({
    error,
    errorMessage,
    extraArguments,
    withNotifications,
}: {
    error: unknown;
    extraArguments?:
        | {
              [key: string]: string;
          }
        | undefined;
    errorMessage: string;
    withNotifications?: boolean;
}) => void;

const useError = ({
    setLoading,
    setPlaying,
    setSources,
}: {
    setLoading: (value: boolean) => void;
    setPlaying: (value: boolean) => void;
    setSources: (value: PlayerSource[]) => void;
}) => {
    const { createNotification } = useNotificationsContext();

    const onError: OnError = useCallback(
        ({ withNotifications = false }) => {
            withNotifications &&
                createNotification(new PlayerFailedToPlayError());

            setLoading(false);
            setPlaying(false);
            setSources([]);
        },
        [createNotification, setSources, setLoading, setPlaying],
    );

    return { onError };
};

export default useError;
